export const LIST_BUILDING_CHECKLIST_DATE = '1900-01-01';
export const LIST_BUILDING_CHECKLIST_DATE_LABEL = 'Date Unknown';
